import React from "react";

import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import QueryBuilder from "../../../../../components/QueryBuilder";

// styles
import css from "./AdditionalFilters.module.scss";

interface BaseProps {
	closePanel: () => void;
}

const AdditionalFilters = (props: BaseProps) => {
	const { closePanel } = props;

	return (
		<div data-testid="additional-filters" className={css.additionalFilterPanel}>
			<div className={css.panelTitleRow}>
				<span>Additional Filters</span>
				<div className={css.closeButton} onClick={closePanel}>
					<div className={css.iconWrapper}>
						<FontAwesomeIcon icon={faChevronLeft} />
					</div>
				</div>
			</div>
			<QueryBuilder />
		</div>
	);
};

export default AdditionalFilters;
